module.exports = __webpack_public_path__ + "media/images/OPL GIANT-90eebbc41407f6327a6d76bf14567e53.png";